import React, { useEffect } from 'react';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { chatHandleColor } from '../../constants/colorsCustom';
import { makeStyles } from '@material-ui/core/styles';
import participantListStyles from '../../styles/participantsListStyles';

const useStyles = makeStyles((theme) => participantListStyles(theme));

function ListContainer({ list = [], boxName = 'Event' }) {
  const classes = useStyles();

  useEffect(() => {
    if (boxName === 'Event') {
      console.log(list.length, '-total event participants');
    }
  }, [boxName, list.length]);

  return (
    <div className={classes.root}>
      <div style={{ width: '100%' }}>
        <Typography gutterBottom noWrap variant='h6' color='primary'>
          {boxName} Participants (active)
        </Typography>
      </div>
      <Grid container>
        <div
          style={{
            color: '#ffffff',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            flexWrap: 'wrap',
            flex: 1,
            width: '100%',
          }}
        >
          {list?.map((participant) => (
            <Grid item xs={6} key={participant?.identity}>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  paddingRight: 20,
                }}
              >
                <Typography
                  // gutterBottom
                  noWrap
                >
                  {participant?.name}
                </Typography>

                <Typography
                  gutterBottom
                  noWrap
                  variant='caption'
                  style={{ color: chatHandleColor }}
                >
                  {`@${participant.tagHandle}`}
                </Typography>
              </div>
            </Grid>
          ))}
        </div>
      </Grid>
    </div>
  );
}

export default ListContainer;
